// extracted by mini-css-extract-plugin
module.exports = {"tabBar":"style_tabBar__3QWS3","tabBar__list":"style_tabBar__list__3L11B","tabBar__item":"style_tabBar__item__2wRJy","tabBar__item--active":"style_tabBar__item--active__1Fxrd"};